import { PropType } from 'vue';
export default {
  name: 'LiveAuctionCard',

  props: {
    cardPxSize: {
      type: Number as PropType<number>,
      required: true,
    },
  },
};
